// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1DJPt","label":"Labeled_label__21Z_R","divider":"Labeled_divider__3pSwK"};